var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporateServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 66 66",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0d4353",
    d: "M35.83 53.33h-5.67c-.54 2.13-1.76 4.83-4.49 6.93h14.65c-2.73-2.1-3.94-4.8-4.49-6.93z",
    opacity: 1,
    "data-original": "#0d4353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e4b5c",
    d: "M61.08 14.62c0-2.67-2.17-4.84-4.84-4.84H9.76c-2.67 0-4.84 2.17-4.84 4.84v31h56.16z",
    opacity: 1,
    "data-original": "#0e4b5c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M57.57 44.17V14.74c0-.8-.65-1.45-1.45-1.45H9.88c-.8 0-1.45.65-1.45 1.45v29.43c0 .8.65 1.45 1.45 1.45h46.23c.81 0 1.46-.65 1.46-1.45z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e4b5c",
    d: "M4.92 45.62v2.86c0 2.67 2.17 4.84 4.84 4.84h46.47c2.67 0 4.84-2.17 4.84-4.84v-2.86z",
    opacity: 1,
    "data-original": "#0e4b5c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#658c99",
    d: "M22.27 63.12c0 .48.39.88.88.88h19.7c.48 0 .88-.39.88-.88a2.86 2.86 0 0 0-2.86-2.86H25.14a2.862 2.862 0 0 0-2.87 2.86z",
    opacity: 1,
    "data-original": "#658c99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.33,
    cy: 49.47,
    r: 0.85,
    fill: "#f6f0f5",
    opacity: 1,
    "data-original": "#f6f0f5",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.99,
    cy: 49.47,
    r: 0.85,
    fill: "#f6f0f5",
    opacity: 1,
    "data-original": "#f6f0f5",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.66,
    cy: 49.47,
    r: 0.85,
    fill: "#f6f0f5",
    opacity: 1,
    "data-original": "#f6f0f5",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f0f5",
    d: "M52.78 45.62V4.91c0-1.6-1.3-2.91-2.91-2.91H16.12c-1.6 0-2.91 1.3-2.91 2.91v40.71z",
    opacity: 1,
    "data-original": "#f6f0f5",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c8fc7",
    d: "M52.78 8.83V4.91c0-1.6-1.3-2.91-2.91-2.91H16.12c-1.6 0-2.91 1.3-2.91 2.91v3.92z",
    opacity: 1,
    "data-original": "#1c8fc7",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M48.59 6.39H34.27c-.54 0-.97-.43-.97-.97s.43-.97.97-.97h14.32c.54 0 .97.43.97.97s-.43.97-.97.97z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.41,
    cy: 5.42,
    r: 0.97,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.94,
    cy: 5.42,
    r: 0.97,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.46,
    cy: 5.42,
    r: 0.97,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7146",
    d: "m38.3 20.06-.5.87c-.21.35-.66.47-1 .27l-2.55-1.48v2.95c0 .41-.33.74-.74.74h-1c-.41 0-.74-.33-.74-.74v-2.94l-2.55 1.47c-.35.2-.8.08-1.01-.27l-.5-.87a.74.74 0 0 1 .27-1.01l2.55-1.47-2.55-1.47a.74.74 0 0 1-.27-1.01l.5-.87c.21-.35.66-.47 1.01-.27l2.55 1.47v-2.95c0-.41.33-.74.74-.74h1c.41 0 .74.33.74.74v2.95l2.55-1.47c.35-.21.8-.09 1 .27l.5.87c.21.35.08.8-.27 1.01l-2.55 1.47 2.55 1.47c.35.2.48.65.27 1.01z",
    opacity: 1,
    "data-original": "#ff7146",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1d9e1",
    d: "M29.18 41.75H18.06c-.54 0-.97-.43-.97-.97s.43-.97.97-.97h11.12a.97.97 0 0 1 0 1.94zM32.92 41.75h-.07c-.54 0-.97-.43-.97-.97s.43-.97.97-.97h.07a.97.97 0 0 1 0 1.94zM47.94 27.92H27.75c-.54 0-.97-.43-.97-.97s.43-.97.97-.97h20.19c.54 0 .97.43.97.97s-.43.97-.97.97zM47.94 32.53H18.06c-.54 0-.97-.43-.97-.97s.43-.97.97-.97h29.88c.54 0 .97.43.97.97s-.43.97-.97.97zM47.94 37.14H18.06c-.54 0-.97-.43-.97-.97s.43-.97.97-.97h29.88c.54 0 .97.43.97.97s-.43.97-.97.97z",
    opacity: 1,
    "data-original": "#e1d9e1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateServices);
export default __webpack_public_path__ + "static/media/corporate_services.37a51ad703f059dd8aa27adcc13434aa.svg";
export { ForwardRef as ReactComponent };